import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet-async';

const Helmet = (props) => (
    <ReactHelmet>
        <title>{props.title}</title>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-D3MGH8PHHL"></script>
        <script>{` window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-D3MGH8PHHL'); `}</script>
    </ReactHelmet>
);

export default Helmet;